import React from 'react';

import PropTypes from 'prop-types';

import Badge from 'modules/common/components/Badge';

import { renderStatusBadge, renderPaymentMethodBadge } from '../constants';

const renderItem = (label, value) => (
  <div className="space-y-2 text-sm">
    <h4 className="font-semibold text-gray-400 text-xs">{label}</h4>
    {value}
  </div>
);

function OrderDetailCard({ data, included }) {
  const {
    scheduled_at,
    is_in_house,
    system_status,
    scheduled_time,
    payment_method,
    is_customer_pickup,
    payment_method_label,
    delivery_courier_label,
  } = data || {};

  return (
    <div className="card">
      <div className="grid gap-5">
        <h4 className="font-semibold">Order Details</h4>
        <div className="flex flex-wrap gap-7">
          {data?.transaction_type !== 'POS'
            ? renderItem(
                'FULFILLMENT',
                <div className="flex flex-col gap-1.5 items-start">
                  {!is_in_house && (
                    <Badge
                      type={is_customer_pickup ? 'info' : 'light'}
                      label={is_customer_pickup ? 'Pick Up' : 'Delivery'}
                    />
                  )}
                  {is_in_house ? <Badge type="info" label="Dine In" /> : ''}
                  {included?.fulfillment?.partner?.name ||
                  delivery_courier_label ? (
                    <Badge
                      type="info"
                      label={
                        included?.fulfillment?.partner?.name ||
                        delivery_courier_label
                      }
                    />
                  ) : null}
                </div>
              )
            : null}
          {scheduled_at &&
            scheduled_time &&
            renderItem(
              'SCHEDULED DELIVERY',
              <Badge
                type="light"
                className="font-medium"
                label={scheduled_at}
              />
            )}
          {renderItem(
            'PAYMENT METHOD',
            <div className="flex flex-col gap-2 items-start">
              <Badge
                type={
                  renderPaymentMethodBadge[payment_method]?.type ||
                  renderPaymentMethodBadge?.DEFAULT?.type
                }
                label={
                  renderPaymentMethodBadge[payment_method]?.label ||
                  renderPaymentMethodBadge?.DEFAULT?.label
                }
              />
              {payment_method_label && (
                <Badge type="info" label={payment_method_label} />
              )}
            </div>
          )}

          {scheduled_at
            ? renderItem(
                'DELIVERY TIME',
                <Badge type="light" label={scheduled_at} />
              )
            : null}

          {renderItem(
            'STATUS',
            <Badge
              type={
                renderStatusBadge[system_status]?.type ||
                renderStatusBadge?.DEFAULT?.type
              }
              label={
                renderStatusBadge[system_status]?.label ||
                renderStatusBadge?.DEFAULT?.label
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}

OrderDetailCard.defaultProps = {
  data: {},
  included: {},
};

OrderDetailCard.propTypes = {
  data: PropTypes.instanceOf(Object),
  included: PropTypes.instanceOf(Object),
};

export default OrderDetailCard;
